var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnPin = function SvgIcnPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.246 10a.74.74 0 0 1-.522-.215l-.63-.63-2.622 2.631a4.958 4.958 0 0 1-1.215 4.99.76.76 0 0 1-1.079 0l-2.464-2.473-2.486 2.486a.72.72 0 1 1-1.018-1.018l2.488-2.487-2.474-2.481a.765.765 0 0 1 0-1.083 4.93 4.93 0 0 1 5.03-1.201l2.598-2.605-.637-.637a.737.737 0 0 1-.059-.975l1.57-2.019a.746.746 0 0 1 .844-.235.734.734 0 0 1 .26.168l4.954 4.954a.735.735 0 0 1 .13.865.745.745 0 0 1-.197.239l-2.02 1.57a.73.73 0 0 1-.451.156Z",
    fill: "#292525"
  })));
};
export default SvgIcnPin;